import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class SuperscriptionItemAPI extends ComponentAPI {
    /**
     * Returns the color of the superscription.
     */
    getColor() {
        return this.state.color;
    }
    /**
     * Sets the color of the superscription.
     *
     * @param color - The color of the superscription.
     */
    setColor(color) {
        this.setState({ color });
    }
    /**
     * Returns the label of the superscription.
     */
    getLabel() {
        return this.state.label;
    }
    /**
     * Sets the label of the superscription.
     *
     * @param label - The label of the superscription.
     */
    setLabel(label) {
        this.setState({ label });
    }
    /**
     * Returns if the label is visible.
     */
    isShowLabel() {
        return this.state.showLabel ?? false;
    }
    /**
     * Sets if the label should be visible.
     *
     * @param showLabel - If the label should be visible.
     */
    setShowLabel(showLabel) {
        this.setState({ showLabel });
    }
}
export { SuperscriptionItemAPI, };
//# sourceMappingURL=superscription-item-api.js.map